import { render, staticRenderFns } from "./GroupMoveSelector.vue?vue&type=template&id=67bd377e&scoped=true"
import script from "./GroupMoveSelector.vue?vue&type=script&lang=js"
export * from "./GroupMoveSelector.vue?vue&type=script&lang=js"
import style0 from "./GroupMoveSelector.vue?vue&type=style&index=0&id=67bd377e&scoped=true&lang=css"
import style1 from "./GroupMoveSelector.vue?vue&type=style&index=1&id=67bd377e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bd377e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67bd377e')) {
      api.createRecord('67bd377e', component.options)
    } else {
      api.reload('67bd377e', component.options)
    }
    module.hot.accept("./GroupMoveSelector.vue?vue&type=template&id=67bd377e&scoped=true", function () {
      api.rerender('67bd377e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/group/GroupMoveSelector.vue"
export default component.exports